import dynamic from "next/dynamic";
import Head from "next/head";
import { useMeasure } from "react-use";
import Banner from "../common/components/Banner";
import Header from "../common/components/Header";
import { useBreakpoint } from "../common/lib/hooks/useWindow";
import {
  HEADER_HEIGHT_MEDIUM,
  HEADER_HEIGHT_MOBILE,
  px,
} from "../common/styles/mixins";
import particleConfig from "../common/particlesjs-config.json";
import { ISourceOptions } from "tsparticles";
import { Content, Main } from "../styles/Metaverse";
import Image from "next/image";
import { useTranslations } from "use-intl";
import { useRouter } from "next/router";

const Particles = dynamic(() => import("react-tsparticles"), {
  ssr: false,
});

const Meta: React.FC = () => {
  const isMedium = useBreakpoint("MEDIUM");
  const [ref, dim] = useMeasure<any>();
  const t = useTranslations("Metaverse");
  const router = useRouter();
  return (
    <>
      <Head>
        <title>{t("meta")} - Spaceship NFT Art Gallery</title>
      </Head>
      <Header />
      <Banner header ref={ref}>
        <Particles
          id="tsparticles"
          height={`${
            dim.height +
            (isMedium ? HEADER_HEIGHT_MEDIUM : HEADER_HEIGHT_MOBILE)
          }px`}
          width={px(dim?.width).toString() || "100vw"}
          options={particleConfig as unknown as ISourceOptions}
        />
        <Content>
          <h1>{t("meta")}</h1>
          <p>{t("subtitle")}</p>
        </Content>
        <div className="shadow" />
      </Banner>
      <Main>
        <h2>{t("galleries.title")}</h2>
        <div>
          <p>{t("galleries.subtitle")}</p>
        </div>
        <div className="galleries-wrapper">
          <div className="gallery-item">
            <a
              target="_blank"
              href={
                "https://app.spatial.io/rooms/617711bc856a8800013b0396?share=8670407756949314948"
              }
            >
              <div className="image-wrapper">
                <Image
                  src="/spatial.png"
                  alt="OnCyber Digital 3D Art Gallery"
                  layout="fill"
                />
              </div>
              <h3>Spatial</h3>
            </a>
          </div>
        </div>
        <div className="galleries-wrapper">
          <div className="gallery-item">
            <a target="_blank" href={"https://app.rarerooms.io/8661"}>
              <div className="image-wrapper">
                <Image
                  src="/rare_rooms.png"
                  alt="OnCyber Digital 3D Art Gallery"
                  layout="fill"
                />
              </div>
              <h3>RareRooms</h3>
            </a>
          </div>
          <div className="gallery-item">
            <a target="_blank" href={"https://oncyber.io/spaceshipnft"}>
              <div className="image-wrapper">
                <Image
                  src="/on_cyber.png"
                  alt="OnCyber Digital 3D Art Gallery"
                  layout="fill"
                />
              </div>
              <h3>OnCyber</h3>
            </a>
          </div>
        </div>
      </Main>
    </>
  );
};

export default Meta;
